import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

import { getNotifications, markNotificationsAsRead } from '../api/notifications';

export const useActivityStore = defineStore('activityNotifications', () => {
	const isNudgeVisible = ref(false);
	const notifications = ref([]);
	const hasUnreadNotifications = ref(false);

	const showNudge = () => {
		isNudgeVisible.value = true;
	};

	const hideNudge = () => {
		isNudgeVisible.value = false;
	};

	const fetchNotifications = async () => {
		try {
			notifications.value = await getNotifications();

			if (notifications.value) {
				hasUnreadNotifications.value = false;
				return;
			}

			hasUnreadNotifications.value = notifications.value.filter((el) => !el.read_at).length;
		} catch (error) {
			notifications.value = [];
			hasUnreadNotifications.value = false;
		}
	};

	const markAllNotificationsAsRead = async () => {
		try {
			await markNotificationsAsRead();

			setTimeout(async () => {
				await fetchNotifications();
			}, 1500);
		} catch (error) {}
	};

	return {
		isNudgeVisible,
		notifications,
		hasUnreadNotifications,
		showNudge,
		hideNudge,
		fetchNotifications,
		markAllNotificationsAsRead,
	};
});
